import { RouteView, PageView } from '@/components/layouts'
// import AccountInfo from '@/views/my-account/jd-recharge/account-info'
// 我的账户
import myAccount from '@/views/my-account/my-account/my-account'
// 保证金账户-支付流水
import payFlow from '@/views/my-account/bzj-account/payFlow'

// 京东附属账户
import jdRecords from '@/views/my-account/jd-recharge/records'
import Payment from '@/views/my-account/jd-recharge/payment'

// 众邦附属账户
import zbRecords from '@/views/my-account/zb-recharge/records'
import zbTransfer from '@/views/my-account/zb-recharge/transfer'
import zbWithdrawal from '@/views/my-account/zb-recharge/withdrawal'
import zbTradingFlow from '@/views/my-account/zb-recharge/tradingFlow'

// 中信附属账户
// import zxWithdrawal from '@/views/my-account/zx-account/withdrawal/withdrawal'

// 诚意金账户
// import cyjAccessMoney from '@/views/my-account/cyj-account/access-money'
import tradingFlow from '@/views/my-account/cyj-account/trading-flow'

// 白糖货款账户
import hkAccessMoney from '@/views/my-account/hk-account/hk-access-money'
import hkrOperation from '@/views/my-account/hk-account/hk-operation'

// 银行卡管理
// import bankCardList from '@/views/bank-card-manage/bank-card-list'

export default {
  path: '/my-account',
  name: '/my-account',
  component: RouteView,
  meta: { title: '我的账户', keepAlive: false, icon: 'iconfont zhanghuliebiao' },
  children: [
    {
      path: '/my-account/myAccount',
      name: '/my-account/myAccount',
      component: PageView,
      meta: { title: '账户首页', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/my-account/myAccount/myAccount',
          name: '/my-account/myAccount/myAccount',
          component: myAccount,
          meta: { title: '我的账户', keepAlive: false, action: [] }
        },
      ]
    },
    {
      path: '/my-account/bzj-account',
      name: '/my-account/bzj-account',
      component: PageView,
      meta: { title: '保证金账户管理', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/my-account/bzj-account/payFlow',
          name: '/my-account/bzj-account/payFlow',
          component: payFlow,
          meta: { title: '支付流水', keepAlive: false, action: [] }
        },
      ]
    },
    {
      path: '/my-account/jdRecharge',
      name: '/my-account/jdRecharge',
      component: PageView,
      meta: { title: '京东支付管理', keepAlive: false, action: [], icon: 'el-icon-star-on' },
      children: [
        {
          path: '/my-account/jdRecharge/records',
          name: '/my-account/jdRecharge/records',
          component: jdRecords,
          meta: { title: '充值管理', keepAlive: false, action: [] }
        },
        {
          path: '/my-account/jdRecharge/payment',
          name: '/my-account/jdRecharge/payment',
          component: Payment,
          meta: { title: '支付管理', keepAlive: false, action: [] }
        },
      ]
    },
    {
      path: '/my-account/hkAccount',
      name: '/my-account/hkAccount',
      component: PageView,
      meta: { title: '货款管理', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/my-account/hkAccount/hkAccessMoney',
          name: '/my-account/hkAccount/hkAccessMoney',
          component: hkAccessMoney,
          meta: { title: '货款账户', keepAlive: false, action: [] }
        },
        {
          path: '/my-account/hkAccount/hkOperation',
          name: '/my-account/hkAccount/hkOperation',
          component: hkrOperation,
          meta: { title: '货款入金', keepAlive: false, action: [] }
        }
      ]
    },
    {
      path: '/my-account/zbRecharge',
      name: '/my-account/zbRecharge',
      component: PageView,
      meta: { title: '众邦支付管理', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/my-account/zbRecharge/zbRecords',
          name: '/my-account/zbRecharge/zbRecords',
          component: zbRecords,
          meta: { title: '充值管理', keepAlive: false, action: [] }
        },
        {
          path: '/my-account/zbRecharge/zbTransfer',
          name: '/my-account/zbRecharge/zbTransfer',
          component: zbTransfer,
          meta: { title: '转账管理', keepAlive: false, action: [] }
        },
        {
          path: '/my-account/zbRecharge/zbWithdrawal',
          name: '/my-account/zbRecharge/zbWithdrawal',
          component: zbWithdrawal,
          meta: { title: '提现管理', keepAlive: false, action: [] }
        },
        {
          path: '/my-account/zbRecharge/zbTradingFlow',
          name: '/my-account/zbRecharge/zbTradingFlow',
          component: zbTradingFlow,
          meta: { title: '交易流水', keepAlive: false, action: [] }
        }
      ]
    },
    // {
    //   path: '/my-account/zxAccount',
    //   name: '/my-account/zxAccount',
    //   component: PageView,
    //   meta: { title: '中信支付管理', keepAlive: false, action: [], icon: 'el-icon-star-on' },
    //   children: [
    //     {
    //       path: '/my-account/zxAccount/zxWithdrawal',
    //       name: '/my-account/zxAccount/zxWithdrawal',
    //       component: zxWithdrawal,
    //       meta: { title: '提现管理', keepAlive: false, action: [] }
    //     }
    //   ]
    // },
    {
      path: '/my-account/cyjAccount',
      name: '/my-account/cyjAccount',
      component: PageView,
      meta: { title: '诚意金账户管理', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        // {
        //   path: '/my-account/cyjAccount/cyjAccessMoney',
        //   name: '/my-account/cyjAccount/cyjAccessMoney',
        //   component: cyjAccessMoney,
        //   meta: { title: '诚意金管理', keepAlive: false, action: [] }
        // },
        {
          path: '/my-account/cyjAccount/trading-flow',
          name: '/my-account/cyjAccount/trading-flow',
          component: tradingFlow,
          meta: { title: '交易流水', keepAlive: false, action: [] }
        }
      ]
    },
    // {
    //   path: '/my-account/zxAccount',
    //   name: '/my-account/zxAccount',
    //   component: PageView,
    //   meta: { title: '中信支付管理', keepAlive: false, icon: 'el-icon-star-on' },
    //   children: [
    //     {
    //       path: '/my-account/zxAccount/zxWithdrawal',
    //       name: '/my-account/zxAccount/zxWithdrawal',
    //       component: zxWithdrawal,
    //       meta: { title: '提现管理', keepAlive: false, action: [] }
    //     }
    //   ]
    // },
    // {
    //   path: '/my-account/bank-card-manage',
    //   name: '/my-account/bank-card-manage',
    //   component: PageView,
    //   meta: { title: '银行卡管理', keepAlive: false, icon: 'el-icon-star-on' },
    //   children: [
    //     {
    //       path: '/bank-card-manage/bankCardList/bankCardList',
    //       name: '/bank-card-manage/sugarAccount/bankCardList',
    //       component: bankCardList,
    //       meta: { title: '银行卡列表', keepAlive: false, action: [] }
    //     },
    //   ]
    // }
  ]
}
